<template>
  <div id="basketball_teamDetail" v-show="currThemeObj">
    <div class="abs_top">
      <teamDetail_matchPanel
        :currThemeObj="currThemeObj"
        :baseInfor="matchPanel_baseInfor"
        :averageArr="matchPanel_averageArr"
      ></teamDetail_matchPanel>
      <div class="selectTab_area">
        <selectTab
          :currThemeObj="currThemeObj"
          :tabArr="tabArr"
          :pageJumpParams="selectTab_pageJumpParams"
          @clickTabEvent="onChangeTab"
          :colorsArr="selectTab_colorsArr"
        ></selectTab>
      </div>
    </div>
    <div>
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :matchInfor="matchPanel_baseInfor"
        :isRefresh="isRefresh"
        :refreshTime="refreshTime"
        :currGroup="currGroup"
        :curTimeZoneItem="curTimeZoneItem"
      ></router-view>
    </div>
  </div>
</template>

<script>
import teamDetail_matchPanel from './teamDetail_matchPanel.vue'
import selectTab from '@components/platfromBase/compreSportsMeet/selectTab.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

import { https_teamDetail_baseInfor } from '@api/platfrom_basketball_api'
export default {
  name: 'basketball_teamDetail',
  components: { teamDetail_matchPanel, selectTab },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      isRefresh: false, //是否需要实时更新
      refreshTime: 30 * 1000, //定时器刷的时间 默认
      setIntervalId: null,
      matchPanel_averageArr: null,
      matchPanel_baseInfor: {
        teamId: '',
        teamName: '',
        teamLogo: '',
        teamWin: '',
        teamLosses: '',
        teamRank: '',
      },
      tabArr: [
        {
          name: '球员名单',
          id: 'playerList',
          pathName: 'teamDetailPlayerList',
          act: true,
        },
        {
          name: '球队数据',
          id: 'teamData',
          pathName: 'teamDetailTeamData',
          act: false,
        },
        {
          name: '比赛统计',
          id: 'matchRecord',
          pathName: 'teamDetailMatchRecord',
          act: false,
        },
        {
          name: '赛程',
          id: 'matchSchedule',
          pathName: 'teamDetailMatchSchedule',
          act: false,
        },
      ],
      selectTab_pageJumpParams: [],
      selectTab_colorsArr: null,
      selectTab_colorsKey: [
        'greyColor7',
        'whiteColor',
        'greyColor2',
        'subColor1_1',
      ],
    }
  },
  watch: {
    isRefresh(newVal, oldVal) {
      console.debug(`lineup isRefresh: ${newVal}, ${oldVal}`)
      if (newVal && !oldVal) {
        this.refreshCallbackHandle()
      } else if (!newVal && oldVal) {
        this.cancelRefreshCallBackHandle()
      }
    },
  },
  created() {
    if (this.currThemeObj) {
      this.tabArr.forEach((item) => {
        item.pathName = `${item.pathName}_${this.currThemeObj.moduleRouteNameEn}` // teamDetailPlayerList_CBA
      })
    }
    const query = this.$route.query
    this.selectTab_pageJumpParams = [query, null]

    this.init(query)
  },
  methods: {
    async init(params) {
      // this.origin_matchList = matchList_mock.dat
      if (params) {
        if (this.currThemeObj) {
          this.selectTab_colorsArr = this.selectTab_colorsKey.map((key) => {
            return this.currThemeObj.cssStyle[key]
          })
        }
        await this.getTeamDetailInfor(params)
      }
    },
    cancelRefreshCallBackHandle() {
      clearInterval(this.setIntervalId)
      this.setIntervalId = null
    },
    refreshCallbackHandle() {
      const query = this.$route.query
      this.setIntervalId = setInterval(() => {
        this.getTeamDetailInfor(query)
      }, this.refreshTime - 0)
    },
    onChangeTab(item) {
      this.tabArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
        } else {
          tabItem.act = false
        }
      })
    },
    formatRanAbbrHandler(num) {
      if (!num) {
        return '-'
      }
      let ceil = ''
      if (num === 1) {
        ceil = 'st'
      } else if (num === 2) {
        ceil = 'nd'
      } else if (num === 3) {
        ceil = 'rd'
      } else {
        ceil = 'th'
      }
      return `${num}${ceil}`
    },
    async getTeamDetailInfor(query) {
      await https_teamDetail_baseInfor(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        tid: query.tid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const data = res.data
            let matchPanel_averageArr = [
              {
                key: 'averagePoints',
                name: '场均得分',
              },
              {
                key: 'averagePointsAllowed',
                name: '场均失分',
              },
              {
                key: 'averageRebounds',
                name: '场均篮板',
              },
              {
                key: 'averageAssists',
                name: '场均助攻',
              },
              {
                key: 'averageTurnovers',
                name: '场均失误',
              },
            ]
            this.matchPanel_averageArr = matchPanel_averageArr.map((item) => {
              item.rank = this.formatRanAbbrHandler(data[`${item.key}Rank`])
              item.val = data[`${item.key}`]
              return item
            })
            this.matchPanel_baseInfor = {
              teamId: data.teamId,
              teamName: data.teamName,
              teamLogo: data.teamLogo,
              teamWin: data.wins,
              teamLosses: data.losses,
              teamRank: data.totalRank,
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#basketball_teamDetail {
  padding-top: 15vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 15vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_detail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .selectTab_area {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      padding: 0 9.722vw;
      width: 100%;
      height: 2.778vw;
    }
  }
}
</style>
